// A fila de envio é única no site: continua enviando enquanto a pessoa
// navega pelo console.

import { api } from "./api";
import { UploadQueue } from "./upload-queue";

export const uploadQueue = new UploadQueue({
  create: (body) => api.unwrap(api.client.POST("/v1/admin/uploads", { body })),
  putPart: (id, n, blob, signal) => api.putUploadPart(id, n, blob, signal),
  complete: (id) => api.unwrap(api.client.POST("/v1/admin/uploads/{id}/complete", { params: { path: { id } } })),
  cancel: async (id) => {
    await api.unwrap(api.client.DELETE("/v1/admin/uploads/{id}", { params: { path: { id } } }));
  },
});
